import axiosAPI from "../middlewares/axios-interceptor";

const checkEligibility = (data: any) => axiosAPI.post("/eligibility", data);

const updateContarctList = (data: any) =>
  axiosAPI.put("/updateContractList", data);

const updateClinicsLists = (data: any) =>
  axiosAPI.put("/updateClinicLists", data);

const updateGPPractices = (data: any) =>
  axiosAPI.put("/updateGPPractices", data);

const getGPDetails = (data: any) =>
  axiosAPI.get(`/get-gp-details?searchText=${data}`);

const getAddressDetails = (data: string) =>
  axiosAPI.get(`/getAddressAutocomplete/${data}`);

const getAddressById = (id: string) => axiosAPI.get(`/getAddressById/${id}`);

const getContractByPostcode = (postcode: string, service_code: string) =>
  axiosAPI.get(
    `/getContractByPostcode?postcode=${postcode}&serviceCode=${service_code}`
  );

const getGPContract = (data: any) =>
  axiosAPI.get(
    `/getContractByGPPostcode?organizationCode=${data.organizationCode}&serviceCode=${data.serviceCode}`
  );

const getTableHeaderForContarctAndGPPostcode = () =>
  axiosAPI.get(`/getTableHeaderForContarctAndGPPostcode`);

const getEditHistory = (data: any) =>
  axiosAPI.get(
    `/questionnaire/answer/getEditHistory?userId=${data.userId}&questionId=${data.questionId}`
  );

export {
  checkEligibility,
  getGPDetails,
  getGPContract,
  getContractByPostcode,
  getEditHistory,
  getTableHeaderForContarctAndGPPostcode,
  updateContarctList,
  updateGPPractices,
  updateClinicsLists,
  getAddressDetails,
  getAddressById,
};
